export const FUZZYSORT_MIN_THRESHOLD = 0.3; // Don't use matches worse than this
export const DEFAULT_MAX_MENU_HEIGHT = 200; // Default max height for the menu
//# sourceMappingURL=constants.js.map